import { orderRequestConstants } from '../_constants/order-request.constants';

// Toggled Buy-Sell Modals Action.
export const toggleOrderRequestModal = () => ({
  type: orderRequestConstants.TOGGLED_ORDER_FUNDS_REQUEST_MODAL
});
export const clearErrorMessage = () => ({
  type: orderRequestConstants.CLEAR_ERROR_MESSAGE
});

// Updated Active Tab (buy, sell, switch).
export const updateActiveTabOrderRequestModal = (tab) => ({
  type: orderRequestConstants.UPDATE_ACTIVE_TAB_ORDER_FUNDS_REQUEST_MODAL,
  payload: tab
});

// Updated Fund Id to order request.
export const updateNavigationFundToOrderRequestModal = (fund) => ({
  type: orderRequestConstants.UPDATE_NAVIGATION_FUND_TO_ORDER_REQUEST_MODAL,
  payload: fund
});
export const clearNavigationFundToOrderRequestModal = () => ({
  type: orderRequestConstants.CLEAR_NAVIGATION_FUND_TO_ORDER_REQUEST_MODAL,
});

// Get Fund Information (Buy, Sell, Switch-Out).
export const fetchBuyFundInfoStart = (data) => ({
  type: orderRequestConstants.FETCH_BUY_FUND_INFO_START,
  payload: data
});
export const fetchSellFundInfoStart = (data) => ({
  type: orderRequestConstants.FETCH_SELL_FUND_INFO_START,
  payload: data
});
export const updateFundInfo = (data) => ({
  type: orderRequestConstants.UPDATE_FUND_INFO,
  payload: data
});
export const clearFundInfo = () => ({
  type: orderRequestConstants.CLEAR_FUND_INFO
});

// Fund Information 2 (Switch-In).
export const fetchSwitchFundInfoStart = (data) => ({
  type: orderRequestConstants.FETCH_SWITCH_FUND_INFO_START,
  payload: data
});
export const updateFundInfo2 = (data) => ({
  type: orderRequestConstants.UPDATE_FUNDS_INFO_2,
  payload: data
});
export const clearSearchFundInfo2 = () => ({
  type: orderRequestConstants.CLEAR_FUND_INFO_2
});

// Checked Fund able to order. (Buy, Switch).
export const clearCheckedFundAble = () => ({
  type: orderRequestConstants.CLEAR_CHECKED_FUND_ABLE
});
export const checkedBuyableFundStart = (data) => ({
  type: orderRequestConstants.CHECKED_BUYABLE_FUND_START,
  payload: data
});
export const checkedSellableFundStart = (data) => ({
  type: orderRequestConstants.CHECKED_SELLABLE_FUND_START,
  payload: data
});
export const checkedSwitchableFundStart = (data) => ({
  type: orderRequestConstants.CHECKED_SWITCHABLE_FUND_START,
  payload: data
});
export const checkedFundAbleToOrderSuccess = (data) => ({
  type: orderRequestConstants.CHECKED_FUND_ABLE_TO_ORDER_SUCCESS,
  payload: data
});
export const checkedFundAbleToOrderFailure = (errorMessage) => ({
  type: orderRequestConstants.CHECKED_FUND_ABLE_TO_ORDER_FAILURE,
  payload: errorMessage
});

// Confirmed Order Fund.
export const confirmOrderFundStart = (data) => ({
  type: orderRequestConstants.CONFIRM_ORDER_FUND_START,
  payload: data
});
export const confirmOrderFundSuccess = (data) => ({
  type: orderRequestConstants.CONFIRM_ORDER_FUND_SUCCESS,
  payload: data
});
export const confirmOrderFundFailure = (data) => ({
  type: orderRequestConstants.CONFIRM_ORDER_FUND_FAILURE,
  payload: data
});
export const resetConfirmOrderFund = () => ({
  type: orderRequestConstants.RESET_CONFIRM_ORDER_FUND
});

// SEARCH FUND INFORMATION
export const clearSearchFundInfo = () => ({
  type: orderRequestConstants.CLEAR_SEARCH_FUNDS_INFO
});
export const updateSearchFundInfo = (searchText) => ({
  type: orderRequestConstants.UPDATE_SEARCH_FUNDS_INFO,
  payload: searchText
});
export const removeSearchFundInfo = () => ({
  type: orderRequestConstants.REMOVE_SEARCH_FUNDS_INFO
});

// PORTIFOLIOS SEARCH
export const updateSearchPortfolios = (searchText) => ({
  type: orderRequestConstants.UPDATE_SEARCH_PORTFOLIOS,
  payload: searchText
});
export const toggleModalMessage = () => ({
  type: orderRequestConstants.TOGGLE_MODAL_MESSAGE
});

// FORM
export const updateLatestPlan = (data) => ({
  type: orderRequestConstants.UPDATE_LATEST_PLAN,
  payload: data
});
export const clearLatestPlan = () => ({
  type: orderRequestConstants.CLEAR_LATEST_PLAN
});
export const updateLatestSettleDate = (data) => {
  console.log(data);
  return {
  type: orderRequestConstants.UPDATE_LATEST_SETTLE_DATE,
  payload: data
}};